const config = {
  BACKEND_URL: "https://botyfi.com"
};
export default config;
export const BACKEND_URL = config.BACKEND_URL;
